import React from 'react';

import { Navigation, utils } from 'htlib-copy';

import './Header.scss';

const { assets } = utils;
const { Navbar } = Navigation;

const Logo = (
  <a href="/missions" className="Header__logo">
    <img src={assets.logos.heuritechMax} alt="logo" />
  </a>
);

const Links = [];

const Actions = [
  <a href="/" key="title" className="Header__title">
    <h2>Labeling&nbsp;checker</h2>
  </a>,
];

export default function Header() {
  return (
    <div className="Header">
      <Navbar Logo={Logo} Content={Links} Actions={Actions} />
    </div>
  );
}
